import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApComplexModal } from 'webcommon/core-ui';
import { RelEmployerItem } from 'webcommon/shared';
import { FcItemModalMode } from '../../../models';

@Component({
  selector: 'fc-new-insurance-period-list-modal',
  templateUrl: './fc-new-insurance-period-list-modal.component.html',
  styleUrls: ['./fc-new-insurance-period-list-modal.component.less']
})
export class FcNewInsurancePeriodListModalComponent extends ApComplexModal<any> implements OnInit {
  public baseId = 'fc-new-insurance-period';
  public isDisabled = false;
  public listItemName = 'Insurance Period';

  public itemForModify: RelEmployerItem | null;
  public mode: number;
  public dataItems: RelEmployerItem[];
  public fcItemModalModeEnum = FcItemModalMode;
  public minDate: Date;
  public maxDate: Date;
  public isShowExpiration = true;

  public effectiveDateControl = new FormControl<Date>(new Date());
  public expirationDateControl = new FormControl<Date | undefined>(undefined);
  public form = new FormGroup({
    EffectiveDate: this.effectiveDateControl,
    ExpirationDate: this.expirationDateControl
  });

  public override ngOnInit(): void {
    super.ngOnInit();
    this.minDate = new Date();
    if (!this.itemForModify?.ExpirationDate) {
      this.expirationDateControl.disable();
    }

    if (this.mode === this.fcItemModalModeEnum.Modify && this.itemForModify) {
      if (this.itemForModify.ExpirationDate) {
        this.expirationDateControl.setValue(new Date(this.itemForModify.ExpirationDate));
      }
      this.effectiveDateControl.setValue(new Date(this.itemForModify.EffectiveDate));
    } else {
      this.effectiveDateControl.setValue(new Date());
      this.expirationDateControl.setValue(undefined);
      this.expirationDateControl.disable();
    }
  }

  public onCancel(): void {
    this.apClose({result: false});
  }

  public onSave(): void {
    const values = {
      id: this.itemForModify ? this.itemForModify.localId : this.getRandomId(),
      ...this.form.getRawValue(),
    };

    this.apClose({result: values});
  }

  public getRandomId(): string {
    const length = 10;
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';

    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('') +
      Math.floor(Math.random() * 100000000000).toString();
  }
}
